import { Component, inject } from '@angular/core';
import { LoaderService } from '@core/services/loader.service';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [],
  template: `
    @if (loader.loading()) {
    <div
      class="fixed inset-0 z-[9998] grid place-items-center bg-black/25 backdrop-blur-[1px]"
    >
      <div class="grid place-items-center gap-3">
        <!-- SVG spinner -->
        <svg
          class="w-12 h-12 animate-[spin_1s_linear_infinite]"
          viewBox="0 0 50 50"
        >
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="currentColor"
            stroke-width="6"
            class="text-white/30"
          />
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="currentColor"
            stroke-width="6"
            stroke-linecap="round"
            stroke-dasharray="31.4 125.6"
            class="text-white"
          />
        </svg>
        <div class="text-white text-sm">Loading…</div>
      </div>
    </div>
    }
  `,
})
export class GlobalLoaderComponent {
  loader = inject(LoaderService);
}
